import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ActivatedRoute, RouterLink, RouterLinkActive } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { Apps } from '../../interfaces/apps.interface';
import { AsyncPipe, NgClass, NgIf, UpperCasePipe } from '@angular/common';
import { Environment } from '../../interfaces/environment.interface';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { map } from 'rxjs';

@Component({
  selector: 'wm-libs-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
  standalone: true,
  imports: [NgIf, NgClass, AsyncPipe, MatButtonModule, RouterLink, UpperCasePipe, RouterLinkActive, TranslateModule],
})
export class PageNotFoundComponent implements OnInit {
  app!: Apps;
  env!: Environment;

  isMobile$ = this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small]).pipe(map((result) => result.matches));

  constructor(private route: ActivatedRoute, private breakpointObserver: BreakpointObserver) {}

  ngOnInit(): void {
    this.route.data.subscribe((data) => {
      this.env = data['env'];
      this.app = data['app'];
    });
  }
}
